export const teachersListTitle = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  { titleName: "name", colWidth: "150px" },
  { titleName: "email", colWidth: "200px" },
  { titleName: "mobile", colWidth: "100px" },
  { titleName: "address", colWidth: "100px" },
  { titleName: "block", colWidth: "80px", key: "blockName" },
  { titleName: "branch", colWidth: "80px", key: "branchName" },
];
